import { admin2 } from '@/api/instance'
import { isBenefitSharingEnabled, resolveBenefitShopScope } from '@/use/useOrgBenefitControl'

// => 創建使用券紀錄
export const CreateCouponRecord = async ({
  shopId,
  memberId,
  couponId,
  originName,
  message,
}) => {
  const res = await admin2({
    method: 'post',
    url: `/${shopId}/couponRecord`,
    data: {
      memberId,
      couponId,
      originName,
      message,
    },
  })
  return res
}

// => 取得使用券紀錄
export const GetCouponRecord = async ({
  shopId,
  start,
  limit,
  MemberId,
  sort,
  status,
  dateRangeType,
  startAt,
  endAt,
  code,
  exchangeCode,
  type,
  isUsed,
  benefitShopScope,
  crossShop,
  grantedShopId,
  redemptionShopId,
}) => {
  const res = await admin2({
    method: 'get',
    url: `/${shopId}/couponRecord`,
    params: {
      start,
      limit,
      MemberId,
      sort,
      status,
      dateRangeType,
      startAt,
      endAt,
      code,
      exchangeCode,
      type,
      isUsed,
      grantedShopId,
      redemptionShopId,
      benefitShopScope: resolveBenefitShopScope({
        benefitShopScope,
        crossShop,
        fallbackCrossShop: isBenefitSharingEnabled('coupon', shopId) ? true : undefined,
      }),
    },
  })
  return res
}

// => 取得使用券紀錄總數
export const GetCouponRecordCount = async ({
  shopId,
  MemberId,
  status,
  dateRangeType,
  startAt,
  endAt,
  code,
  exchangeCode,
  type,
  isUsed,
  benefitShopScope,
  crossShop,
  grantedShopId,
  redemptionShopId,
}) => {
  const res = await admin2({
    method: 'get',
    url: `/${shopId}/couponRecord/count`,
    params: {
      MemberId,
      status,
      dateRangeType,
      startAt,
      endAt,
      code,
      exchangeCode,
      type,
      isUsed,
      grantedShopId,
      redemptionShopId,
      benefitShopScope: resolveBenefitShopScope({
        benefitShopScope,
        crossShop,
        fallbackCrossShop: isBenefitSharingEnabled('coupon', shopId) ? true : undefined,
      }),
    },
  })
  return res
}

// => 查找使用券紀錄
export const FindCouponRecord = async ({ shopId, id }) => {
  const res = await admin2({
    method: 'get',
    url: `/${shopId}/couponRecord/count/${id}`,
  })
  return res
}
// => 使用使用券
export const UseCoupon = async ({ shopId, id }) => {
  return await admin2({
    method: 'POST',
    url: `/${shopId}/couponRecord/${id}/use`,
  })
}

/**
 * 標記作廢票券紀錄 admin.couponRecord.markVoid
 * @param {Object} options - 參數物件
 * @param {string} options.shopId - 商店 ID
 * @param {string} options.id - 票券紀錄 ID
 * @returns {Promise<Array>} 回傳更新後的 CouponRecord 物件或錯誤訊息
 */
export const MarkVoidCouponRecord = async ({ shopId, id }) => {
  return await admin2({
    method: 'POST',
    url: `/${shopId}/couponRecord/${id}/markVoid`,
  })
}
